export { default as useNativeOpenSoftPullOnClick } from './useNativeOpenSoftPullOnClick';
